<template>
  <div>
    <v-tabs v-model="tab" fixed-tabs background-color="grey lighten-5" color="primary">
      <v-tab v-for="(item, index) in options" :key="index">
        {{
        item.title
        }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item v-for="(item, index) in options" :key="index">
        <export-items :obj="item"></export-items>
        <upload :obj="item"></upload>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { VueCsvImport } from "vue-csv-import";
import upload from "./upload";
import exportItems from "./exportItems";
import moment, { min } from "moment";

export default {
  components: {
    VueCsvImport,
    upload,
    exportItems
  },
  data() {
    return {
      tab: 0,
      options: [
        {
          title: "Candidates",
          fields: { candidateName: "Candidate Name" },
          data: null
        },
        {
          title: "Clients",
          fields: {
            companyName: "Company Name",
            dateReg: "Date Reg",
            sites: "Sites",
            contactName: "Contact Name",
            title: "Title",
            roles: "Roles",
            type: "Type",
            period: "Period",
            frequency: "Frequency",
            structure: "Structure",
            hours: "Hours",
            rate: "Rate",
            expenses: "Expenses",
            expenseRate: "Expenses Rate",
            rate: "Rate",
            street: "Street",
            city: "City",
            postcode: "Postcode"
          },
          data: null
        },
        {
          title: "Timesheets",
          fields: {
            weekCommencing: "Week Commencing",
            invoiceNo: "Invoice No",
            invoiceID: "Invoice ID",
            candidateId: "Candidate ID",
            candidateName: "Candidate Name",
            location: "Location",
            clientId: "Client ID",
            clientName: "Client Name",
            description: "Description",
            site: "Site",
            role: "Role",
            type: "Type",
            period: "Period",
            frequency: "Frequency",
            hours: "Hours",
            rate: "Rate",
            overtime: "Overtime",
            expenseQty: "Expense Qty",
            expenseRate: "Expense Rate",
            info: "Info",
            date: "Date",
            start: "Start",
            finish: "Finish",
            breaks: "Breaks"
          },
          data: null
        },
        {
          title: "Invoices",
          fields: {
            clientId: "Client ID",
            clientName: "Client Name",
            invoiceNo: "Invoice No",
            date: "Date",
            start: "Start",
            finish: "Finish",
            subtotal: "Subtotal",
            vat: "Vat"
          },
          data: null
        }
      ]
    };
  },
  watch: {
    options: {
      handler: function(val, oldVal) {
        val.forEach(v => {
          if (v.title == "Clients" && v.csv) {
            var data = this.createClients(v.csv);
            console.log(data);
            if (v.data == null) {
              v.data = data;
            }
          } else if (v.title == "Candidates" && v.csv) {
            var data = this.createCandidates(v.csv);
            console.log(data);
            if (v.data == null) {
              v.data = data;
            }
          } else if (v.title == "Invoices" && v.csv) {
            var data = this.createInvoices(v.csv);
            console.log(data);
            if (v.data == null) {
              v.data = data;
            }
          } else if (v.title == "Timesheets" && v.csv) {
            var data = this.createTimesheets(v.csv);
            console.log(data);
            if (v.data == null) {
              v.data = data;
            }
          }
        });
      },
      deep: true
    }
  },
  methods: {
    copyToClipboard(text) {
      var dummy = document.createElement("textarea");
      // to avoid breaking orgain page when copying more words
      // cant copy when adding below this code
      // dummy.style.display = 'none'
      document.body.appendChild(dummy);
      //Be careful if you use texarea. setAttribute('value', value), which works with "input" does not work with "textarea". – Eduard
      dummy.value = text;
      dummy.select();
      document.execCommand("copy");
      document.body.removeChild(dummy);
    },
    createCandidates(val) {
      var candidates = [...val];
      return candidates.map(c => {
        return {
          name: c.candidateName
        };
      });
    },
    createTimesheets(val) {
      var helper = {};
      var timesheets = [...val];
      var result = timesheets.reduce((r, o) => {
        var key = `${o.weekCommencing} ${o.candidateId}`;

        if (!helper[key]) {
          // helper[key] = Object.assign({}, o); // create a copy of o
          helper[key] = {
            candidate: {
              _id: o.candidateId,
              name: o.candidateName
            },
            weekCommencing: moment(o.weekCommencing).toISOString(),
            location: o.location
          };
          helper[key].bookings = [];
          helper[key].expenses = [];
          this.addBookingTo(helper[key], o);
          r.push(helper[key]);
        } else {
          this.addBookingTo(helper[key], o);
        }

        return r;
      }, []);

      return result;
    },
    addBookingTo(obj, o) {
      if (o.date == "EXPENSE") {
        obj.expenses.push({
          invoice: {
            _id: o.invoiceID,
            invoiceNo: o.invoiceNo
          },
          candidate: {
            _id: o.candidateId,
            name: o.candidateName
          },
          client: {
            _id: o.clientId,
            name: o.clientName
          },
          type: o.description,
          amount: o.expenseRate
            .replace("£", "")
            .replace(",", "")
            .replace("-", "")
            .trim(),
          quantity: o.expenseQty
        });
      } else {
        var start = moment(o.date + " " + o.start);
        var finish = moment(o.date + " " + o.finish);
        if (finish.isBefore(start)) {
          finish.add(1, "days");
        }
        obj.bookings.push({
          invoice: {
            _id: o.invoiceID,
            invoiceNo: o.invoiceNo
          },
          candidate: {
            _id: o.candidateId,
            name: o.candidateName
          },
          client: {
            _id: o.clientId,
            name: o.clientName
          },
          site: o.site,
          role: o.role,
          type: o.type,
          period: o.period,
          frequency: o.frequency,
          hours: o.hours,
          rate: o.rate
            .replace("£", "")
            .replace(",", "")
            .replace("-", "")
            .trim(),

          overtime: o.overtime
            .replace("£", "")
            .replace(",", "")
            .replace("-", "")
            .trim(),

          info: o.info.replace("-", ""),
          start: start.toISOString(),
          finish: finish.toISOString(),
          breaks: o.breaks
        });
      }
    },
    createInvoices(val) {
      var invoices = [...val];
      var result = invoices.map(i => {
        return {
          client: {
            _id: i.clientId,
            name: i.clientName
          },
          invoiceNo: i.invoiceNo,
          date: moment(i.date).toISOString(),
          start: moment(i.start)
            .startOf("Day")
            .toISOString(),
          finish: moment(i.finish)
            .endOf("Day")
            .toISOString(),
          subtotal: i.subtotal.replace("£", "").replace(",", ""),
          vat: i.vat.replace("£", "").replace(",", "")
        };
      });
      return result;
    },
    createClients(val) {
      var helper = {};
      var clients = [...val];
      var result = clients.reduce((r, o) => {
        var key = o.companyName;

        if (!helper[key]) {
          // helper[key] = Object.assign({}, o); // create a copy of o
          helper[key] = {
            name: o.companyName,
            registered: o.dateReg,
            address: {
              address: o.street,
              city: o.city,
              postcode: o.postcode
            }
          };
          helper[key].sites = [];
          helper[key].rates = [];
          helper[key].expenses = [];

          this.addTo(helper[key], o);
          r.push(helper[key]);
        } else {
          this.addTo(helper[key], o);
        }

        return r;
      }, []);

      result.forEach(c => {
        var rates = [];
        c.rates.forEach(r => {
          var roles = r.roles.split(",");
          var existingRate = rates.find(rate => {
            return rate.roles.every(e => roles.includes(e));
          });
          if (existingRate) {
            existingRate.rates.push(r);
          } else {
            rates.push({
              roles: roles,
              rates: [r]
            });
          }
        });
        c.rates = rates;
      });

      return result;
    },
    addTo(obj, o) {
      if (o.sites) {
        obj.sites.push({
          name: o.sites,
          contacts: []
        });
      }
      if (o.contactName) {
        obj.sites[0].contacts.push({
          name: o.contactName,
          description: o.title
        });
      }
      if (o.expenses && o.expenseRate) {
        obj.expenses.push({
          type: o.expenses,
          rate: Number(o.expenseRate.replace(/[^0-9.-]+/g, ""))
        });
      }
      if (
        o.roles &&
        o.type &&
        o.period &&
        o.frequency &&
        o.structure &&
        o.hours &&
        o.rate
      ) {
        var rate = obj.rates.find(r => {
          return (
            r.roles == o.roles &&
            r.type == o.type &&
            r.period == o.period &&
            r.frequency == o.frequency
          );
        });
        if (rate) {
          if (o.structure == "Overtime") {
            rate.overtime = Number(o.rate.replace(/[^0-9.-]+/g, ""));
          } else {
            rate.rate = Number(o.rate.replace(/[^0-9.-]+/g, ""));
          }
        } else {
          var rate = {
            roles: o.roles,
            type: o.type,
            period: o.period,
            frequency: o.frequency
          };
          if (o.frequency == "Set Rate") {
            rate.rate = Number(o.rate.replace(/[^0-9.-]+/g, ""));
          } else {
            if (o.structure == "Overtime") {
              rate.overtime = Number(o.rate.replace(/[^0-9.-]+/g, ""));
            } else {
              rate.rate = Number(o.rate.replace(/[^0-9.-]+/g, ""));
            }
            if (o.hours != "FLAT") {
              rate.hours = Number(o.hours);
            }
          }
          obj.rates.push(rate);
        }
      }
    }
  }
};
</script>

<style>
.tableClass td,
th {
  padding: 10px;
  border-bottom: 1px solid #ddd;
}
</style>
